import axios from "axios";

// import { BASE_URL, TOKEN } from "../../utils/Constants";

//add your BASE_URL to Constants file

// console.log(BASE_URL);

const baseURL = process.env.REACT_APP_BASE_URL;

const axiosInstance = axios.create({
  baseURL: `${baseURL}/web`,
  withCredentials: true,
});

// axiosInstance.defaults.xsrfHeaderName = "X-CSRFTOKEN";
// axiosInstance.defaults.xsrfCookieName = "csrftoken";

export { axiosInstance };

axiosInstance.interceptors.request.use((config) => {
  // Attach token dynamically (if needed)
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Example: global loader start
  // store.dispatch(loader(true));

  return config;
});

// Handle response process
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalConfig = error.config;
    const token = localStorage.getItem("token");

    if (token && error.response?.status === 401 && !originalConfig._retry) {
      originalConfig._retry = true;

      // Clear local storage and redirect to login
      localStorage.clear(); // or just remove token if needed
      window.location.href = "/auth/login"; // adjust path if needed
    }

    return Promise.reject(error);
  }
);
